/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal';

import { X } from '../../Constants/assets';

/*
This Modal appears when a milestone is reached. Have a different design when the Mileston is the
first one. The handleMilestoneStatus function return the stage of the milestone.
There is 5 different milestone stages
*/
const InnerContainer = styled.div`
    width: 520px;
    height: max-content;
    padding: 35px 10px;
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: center;
    position: fixed;
    font-family: 'Roboto', sans-serif;
    z-index: 100;
    animation: zoomIn 0.2s ease-in-out;
`;
const TextContainer = styled.div`
`;

const HeaderText = styled.div`
    font-weight: bold;
    font-size: 24px;
    line-height: 12%;
    color: ${props => props.theme.colors.black};
    height: 15%;
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
`;
const ParagraphText = styled.div`
    font-size: 16px;
    color: ${props => props.theme.colors.black};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;
const ParagraphListOfItems = styled.div`
    text-align: center;
    height: max-content;
    width: 80%;
    padding: 25px 0px 40px 0px;
    justify-content: center;
    display: flex;
    justify-content: space-around;
    align-items: center;
`;
const ParagraphFirstLine = styled.div`
    text-align: center;
    width: 60%;
`;
const ButtonContainer = styled.button`
    height: 100%;
    padding: 10px 25px;
    background: ${props => props.theme.colors.darkGreen};
    border-radius: 8px;
    cursor: pointer;
    border: none;
`;
const SeeInfoButtonContainer = styled.button`
    width: 40%;
    height: 75%;
    background: ${props => props.theme.colors.white};
    border: 1px solid ${props => props.theme.colors.darkGreen};
    border-radius: 8px;
    box-sizing: border-box;
    cursor: pointer;
`;
const ButtonContainerLine = styled.div`
    height: 50px;
`;
const GetStartedButton = styled.div`
    font-weight: bold;
    font-size: 16px;
    color: ${props => props.theme.colors.white};
    width: 100%;
`;
const ShowInfoButton = styled.div`
    font-weight: bold;
    font-size: 16px;
    line-height: 2.05vh;
    color: ${props => props.theme.colors.darkGreen};
    width: 100%;
`;
const Link = styled.div`
    text-decoration: underline;
    color: #005857;
    padding: 0px 10px;
`;

const ModalContainer = styled.div`
    position: absolute;
    left: 800px;
    bottom: 500px;
    z-index: 2;
`;
const XContainer = styled.div`
    position: absolute;
    right: 30px;
    top: 15px;
    z-index: 100;
`;
const NotEnoughResourcesPopUp = ({
    toggleNoFundsModal,
    showThisModal,
    openStage,
    toggleProject,
    position,
    toggleResources,
    toggleShow,
    handleCard,
    toggleNotEnoughResourcesPopUp,
    checkedPmCount,
    additionalBudget,
    commentAdditionalBudget,
    onlyShowModal,
    toggleModal,
    toggleProjectNeedToBeDisabled,
    toggleDisableScreen,
    setShowOpenProjectSheetAfterBack,
}) => {
    const { t } = useTranslation();
    const [additionalBudgetValid, setAdditionalBudgetValid] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [modalContent, setModalContent] = useState("modals.additional_budget.info_text");
    const [modalTitle, setModalTitle] = useState('modals.additional_budget.info_title');
    const [additionalBudgetPopUp, setAdditionalBudgetPopUp] = useState(false);
    const [burgerStatus, setBurgerStatus] = useState(false);
    const [modalStage, setModalStage] = useState(0);
    if (showThisModal == false) return null;
    const pluralOrNotText = () => {
        if (checkedPmCount > 1) {
            return t('modals.not_enough_resources.cannot_execute_tasks');
        }
        return t('modals.not_enough_resources.cannot_execute_task');
    };
    return (
        <>
            <ModalContainer>
                {' '}
                <Modal
                    style={{}}
                    modalTitle={modalTitle}
                    modalText={modalContent}
                    modalButton="modals.additional_budget.button1"
                    additionalBudgetValid={additionalBudgetValid}
                    modalButtonContinue="modals.additional_budget.button2"
                    toggleShow={() => setModalShow(false)}
                    show={modalShow}
                    additionalBudget={additionalBudget}
                    commentAdditionalBudget={commentAdditionalBudget}
                    setAdditionalBudgetPopUp={setAdditionalBudgetPopUp}
                    modalStage={modalStage}
                    toggleModal={toggleModal}
                />
            </ModalContainer>
            {showThisModal && (
                <InnerContainer>
                    <TextContainer>
                        <XContainer
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                toggleNotEnoughResourcesPopUp(false);
                                toggleProjectNeedToBeDisabled(false);
                            }}
                        >
                            <X />
                        </XContainer>
                        <HeaderText>{t('modals.not_enough_resources.info_title')}</HeaderText>
                        <ParagraphText>
                            <ParagraphFirstLine>{pluralOrNotText()} </ParagraphFirstLine>
                            <ParagraphListOfItems>
                                <Link
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        toggleNotEnoughResourcesPopUp(false);
                                        toggleResources('Buy resources');
                                        toggleProject(openStage);
                                        setShowOpenProjectSheetAfterBack(true);
                                        toggleProjectNeedToBeDisabled(false);
                                        toggleDisableScreen(false);
                                    }}
                                >
                                    {t('global_variables.get_resources_link')}
                                </Link>
                                <Link
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        console.log("i am here2");
                                        toggleNotEnoughResourcesPopUp(false);
                                        onlyShowModal(
                                            "modals.additional_budget.info_title",
                                            "modals.additional_budget.info_text",
                                            "modals.additional_budget.button1",
                                        );
                                        toggleProjectNeedToBeDisabled(false);
                                    }}
                                >
                                    {t('modals.not_enough_resources.additional_budget_link')}
                                </Link>
                            </ParagraphListOfItems>
                        </ParagraphText>
                    </TextContainer>
                    <ButtonContainerLine>
                        <ButtonContainer
                            onClick={() => {
                                handleCard('Delay');
                                toggleNotEnoughResourcesPopUp(false);
                                // toggleProject(0);
                                toggleProject(openStage);
                                toggleProjectNeedToBeDisabled(false);
                            }}
                        >
                            <GetStartedButton>
                                {t('modals.not_enough_resources.button1')}
                            </GetStartedButton>
                        </ButtonContainer>
                    </ButtonContainerLine>
                </InnerContainer>
            )}
            {!showThisModal && modalShow && (
                <InnerContainer>
                    <TextContainer>
                        <HeaderText>{t('modals.not_enough_resources.info_title')}</HeaderText>
                        <ParagraphText>
                            <ParagraphFirstLine>{pluralOrNotText()} </ParagraphFirstLine>
                            <ParagraphListOfItems>
                                <Link
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        setModalShow(false);
                                        toggleResources('Buy resources');
                                        toggleProject(openStage);
                                        toggleProjectNeedToBeDisabled(false);
                                    }}
                                >
                                    {t('global_variables.get_resources_link')}
                                </Link>
                                <Link
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        // additionalBudget(true);
                                        setModalShow(false);
                                        setModalShow(true);
                                    }}
                                >
                                    {t('modals.not_enough_resources.additional_budget_link')}
                                </Link>
                            </ParagraphListOfItems>
                        </ParagraphText>
                    </TextContainer>
                    <ButtonContainerLine>
                        <ButtonContainer
                            onClick={() => {
                                handleCard('Delay');
                                toggleNotEnoughResourcesPopUp(false);
                                toggleProject(openStage);
                                toggleProjectNeedToBeDisabled(false);
                            }}
                        >
                            <GetStartedButton>
                                {t('modals.not_enough_resources.button1')}
                            </GetStartedButton>
                        </ButtonContainer>
                    </ButtonContainerLine>
                </InnerContainer>
            )}
        </>
    );
};
export default React.memo(NotEnoughResourcesPopUp);
